import classNames from 'classnames';
import SignatureCanvas from 'react-signature-canvas';
import { t } from 'ttag';
import CustomButton from '../../customButton';
import './signatureInput.scss';
import type { SignatureInputProps } from './types';
import { useSignatureInput } from './useSignatureInput';

/**
 * Canvas pad for capturing a hand-drawn signature. Renders SignatureCanvas at the given width and height over a white background, marks it disabled through a class when disabled, commits strokes via onEnd from useSignatureInput, and exposes a Clear button calling onClickEraser.
 *
 * @param props - Optional title and class name, canvas width and height, disabled flag and the signature change handler.
 * @returns The rendered signature input element.
 */
const SignatureInput = (props: SignatureInputProps) => {
  const { className = undefined, title = '', width = 552, height = 300, disabled } = props;
  const { signatureCanvasRef, onEnd, onClickEraser } = useSignatureInput(props);

  return (
    <div className={classNames('custom-signature-input-v2', className)}>
      {!!title && <div className="custom-signature-input-v2__title">{title}</div>}
      <div className="signature-canvas-container">
        <SignatureCanvas
          ref={signatureCanvasRef}
          canvasProps={{
            width,
            height,
            className: classNames('signature-canvas', disabled ? '--disabled' : ''),
          }}
          onEnd={onEnd}
          backgroundColor="rgb(255, 255, 255)"
        />
        <div className="dash-line" />
        <CustomButton
          id="clear-btn"
          className="clear-btn"
          disabled={disabled}
          onClick={onClickEraser}
          type="outline"
          size="small"
        >
          {t`Clear`}
        </CustomButton>
      </div>
    </div>
  );
};

export default SignatureInput;
